// File needs to import `displayDate` to avoid breaking changes.
/* eslint-disable import/no-deprecated */

import { displayDate } from '@adsk/alloy-react-helpers';

import { DatePickerDate, Format } from '../types';

export default function getFieldValue({
  date,
  startDate,
  endDate,
  range,
  format,
  locale,
}: {
  date?: DatePickerDate | null;
  startDate?: DatePickerDate | null;
  endDate?: DatePickerDate | null;
  range?: boolean;
  format?: Format;
  locale?: string;
}): string | null | [string | null, string | null] {
  if (range) {
    return [
      startDate
        ? displayDate(startDate, {
            format,
            locale,
            useBrowserTimeZone: true,
            suppressDeprecationWarnings: true,
          })
        : null,
      endDate
        ? displayDate(endDate, {
            format,
            locale,
            useBrowserTimeZone: true,
            suppressDeprecationWarnings: true,
          })
        : null,
    ];
  } else {
    return date
      ? displayDate(date, {
          format,
          locale,
          useBrowserTimeZone: true,
          suppressDeprecationWarnings: true,
        })
      : null;
  }
}
